import './SettingsPopup.css'

import React from 'react'
import Popup from '../../../../popup/Popup'
import Switch from '../../../../switch/Switch'
import Settings from '../../../../../Settings'

export default class SettingsPopup extends React.Component {

  constructor(...props) {
    super(...props)

    this._settings = Settings.get('game')

    this.state = {
      settings: this._settings.read(),
    }

    this._coordsRef = React.createRef()
    this._soundsRef = React.createRef()
    this._highlightMovableRef = React.createRef()
    this._showLastMoveRef = React.createRef()
    this._showAvailableSquares = React.createRef()
    this._switchDarkMode = React.createRef()
    this._showCapturedRef = React.createRef()
  }

  _setMode() {
    const body = document.querySelector('body')
    if (this._switchDarkMode.current.checked) {
      body.classList.add('theme--dark')
    } else {
      body.classList.remove('theme--dark')
    }
    return this._switchDarkMode.current.checked
  }

  render() {
    return (
      <Popup
        className="settings"
        title="Settings"
        closable={true}
        buttons={[
          { text: 'Cancel', secondary: true },
          {
            text: 'Save',
            handler: () => {
              this._settings.write({
                coords: this._coordsRef.current.checked,
                sounds: this._soundsRef.current.checked,
                highlightMovable: this._highlightMovableRef.current.checked,
                showLastMove: this._showLastMoveRef.current.checked,
                showAvailableSquares: this._showAvailableSquares.current.checked,
                switchDarkMode: this._setMode(),
                //showCaptured: this._showCapturedRef.current.checked
              })
            },
          },
        ]}
        onClose={this.props.onClose}
      >
        <Switch
          text="Show coordinates"
          checked={this.state.settings.coords}
          ref={this._coordsRef}
        />
        <Switch
          text="Play sounds"
          checked={this.state.settings.sounds}
          ref={this._soundsRef}
        />
        <Switch
          text="Highlight pieces with legal move"
          checked={this.state.settings.highlightMovable}
          ref={this._highlightMovableRef}
        />
        <Switch
          text="Show last move"
          checked={this.state.settings.showLastMove}
          ref={this._showLastMoveRef}
        />
        <Switch
          text="Show available squares for a selected piece"
          checked={this.state.settings.showAvailableSquares}
          ref={this._showAvailableSquares}
        />
        <Switch
          text="Dark mode"
          checked={this.state.settings.switchDarkMode}
          ref={this._switchDarkMode}
        />
        {/* <Switch text="Show captured pieces" checked={this.state.settings.showCaptured} ref={this._showCapturedRef} disabled={true} /> */}
      </Popup>
    )
  }
}
